import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState, AppThunk, AppDispatch } from '../../store';

type Filters = {
  publishers: Array<string>;
  domains: Array<string>;
  subDomains: Array<string>;
  tags: Array<string>;
  shouldShowFavourites: boolean;
};

export const initialState: Filters = {
  publishers: [],
  domains: [],
  subDomains: [],
  tags: [],
  shouldShowFavourites: false,
};

export const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    filterPublishers: (
      state,
      { payload: publisher }: PayloadAction<string>,
    ) => {
      if (state.publishers.includes(publisher)) {
        state.publishers.splice(state.publishers.indexOf(publisher), 1);
      } else {
        state.publishers.push(publisher);
      }
    },
    filterDomains: (state, { payload: domain }: PayloadAction<string>) => {
      if (state.domains.includes(domain)) {
        state.domains.splice(state.domains.indexOf(domain), 1);
      } else {
        state.domains.push(domain);
      }
    },
    filterSubDomains: (
      state,
      { payload: subDomain }: PayloadAction<string>,
    ) => {
      if (state.subDomains.includes(subDomain)) {
        state.subDomains.splice(state.subDomains.indexOf(subDomain), 1);
      } else {
        state.subDomains.push(subDomain);
      }
    },
    filterTags: (state, { payload: tag }: PayloadAction<string>) => {
      if (state.tags.includes(tag)) {
        state.tags.splice(state.tags.indexOf(tag), 1);
      } else {
        state.tags.push(tag);
      }
    },
    toggleFavouritesFilter: (state) => {
      state.shouldShowFavourites = !state.shouldShowFavourites;
    },
    clearFilters: (state) => {
      state.publishers = [];
      state.domains = [];
      state.subDomains = [];
      state.tags = [];
      state.shouldShowFavourites = false;
    },
  },
});

export const {
  filterPublishers,
  filterDomains,
  filterSubDomains,
  filterTags,
  toggleFavouritesFilter,
  clearFilters,
} = filterSlice.actions;

//Thunks

// Don't actually need these, I think... :-)
// const deselectUnavailableFilters = () => async (dispatch, getState) => {
//   console.log('deselecting');
//   //
// };
// export const setPublishersFilter =
//   (value: Array<string>) => async (dispatch:AppDispatch, getState) => {
//     dispatch(filterPublishers(value));
//     dispatch(deselectUnavailableFilters());
//   };
// export const setDomainsFilter =
//   (value: Array<string>) => async (dispatch:AppDispatch, getState) => {
//     dispatch(filterDomains(value));
//     dispatch(deselectUnavailableFilters());
//   };
// export const setTagsFilter =
//   (value: string) => async (dispatch:AppDispatch, getState) => {
//     dispatch(filterTags(value));
//     dispatch(deselectUnavailableFilters());
//   };

//Selectors
export const selectFilters = (state: RootState) => state.filters;

export const hasGoalFilters = (state: RootState) => {
  const { publishers, domains, subDomains, tags, shouldShowFavourites } = selectFilters(state);
  return (
    [publishers, domains, subDomains, tags, shouldShowFavourites].reduce(
      (sum, arr) => sum + ( Array.isArray(arr) ? arr.length : arr ? 1 : 0 ),
      0,
    ) > 0
  );
};

export default filterSlice.reducer;
